const menu = {
    profile: 'โปรไฟล์',
    language: 'ภาษา',
    appearance: {
        label: 'รูปลักษณ์',
        light: 'โหมดสว่าง',
        dark: 'โหมดมืด',
        system: 'ซิงค์กับระบบ',
    },
    sign_out: 'ออกจากระบบ',
};
export default Object.freeze(menu);
